function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "101",
  height: "50",
  viewBox: "0 0 101 50"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "43.7",
  height: "16",
  x: "1.3",
  y: "1",
  stroke: "currentColor",
  strokeWidth: "2",
  rx: "3"
}), /*#__PURE__*/React.createElement("rect", {
  width: "5",
  height: "2",
  x: "6.3",
  y: "6",
  fill: "currentColor",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  width: "43.7",
  height: "16",
  x: "1.3",
  y: "17",
  stroke: "currentColor",
  strokeWidth: "2",
  rx: "3"
}), /*#__PURE__*/React.createElement("rect", {
  width: "5",
  height: "2",
  x: "6.3",
  y: "22",
  fill: "currentColor",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  width: "43.7",
  height: "16",
  x: "1.3",
  y: "33",
  stroke: "currentColor",
  strokeWidth: "2",
  rx: "3"
}), /*#__PURE__*/React.createElement("rect", {
  width: "5",
  height: "2",
  x: "6.3",
  y: "38",
  fill: "currentColor",
  rx: "1"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2",
  d: "M61.1 29V13M91 29V13"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: "2",
  d: "M52 33a3 3 0 013-3h41.7a3 3 0 013 3v13a3 3 0 01-3 3H55a3 3 0 01-3-3V33z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2",
  d: "M52 45.1h46.8"
}), /*#__PURE__*/React.createElement("rect", {
  width: "4",
  height: "2",
  x: "56.5",
  y: "38.5",
  fill: "currentColor",
  rx: "1",
  transform: "rotate(-90 56.5 38.5)"
}), /*#__PURE__*/React.createElement("rect", {
  width: "4",
  height: "2",
  x: "61.5",
  y: "38.5",
  fill: "currentColor",
  rx: "1",
  transform: "rotate(-90 61.5 38.5)"
}), /*#__PURE__*/React.createElement("rect", {
  width: "4",
  height: "2",
  x: "66.4",
  y: "38.5",
  fill: "currentColor",
  rx: "1",
  transform: "rotate(-90 66.4 38.5)"
}), /*#__PURE__*/React.createElement("rect", {
  width: "4",
  height: "2",
  x: "71.4",
  y: "38.5",
  fill: "currentColor",
  rx: "1",
  transform: "rotate(-90 71.4 38.5)"
})));